import ExcelJS from "exceljs";

export async function streamExportXlsx(stream: ReadableStream<Uint8Array>): Promise<Blob> {
  const workbook = new ExcelJS.Workbook();
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  const sheets = new Map<string, ExcelJS.Worksheet>();
  let ended = false;

  function handle(obj: Record<string, unknown>): void {
    if (obj.type === "sheet") {
      const ws = workbook.addWorksheet(obj.name as string);
      ws.addRow(obj.columns as unknown[]);
      ws.getRow(1).font = { bold: true };
      sheets.set(obj.name as string, ws);
    } else if (obj.type === "row") {
      const ws = sheets.get(obj.sheet as string);
      if (!ws) throw new Error(`row for unknown sheet: ${obj.sheet as string}`);
      ws.addRow(obj.cells as unknown[]);
    } else if (obj.type === "end") {
      ended = true;
    } else if (obj.type === "error") {
      throw new Error(obj.message as string);
    }
  }

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let nl: number;
    while ((nl = buffer.indexOf("\n")) >= 0) {
      const line = buffer.slice(0, nl).trim();
      buffer = buffer.slice(nl + 1);
      if (line) handle(JSON.parse(line));
    }
  }
  buffer += decoder.decode();
  if (buffer.trim()) handle(JSON.parse(buffer.trim()));

  if (!ended) throw new Error("export stream ended without 'end'");

  const buf = await workbook.xlsx.writeBuffer();
  return new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
}
